import {
    Flex,
    FormControl,
    FormErrorMessage,
    InputProps,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputProps,
    NumberInputStepper,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from './FormInput';
import { FormLabel } from './FormLabel';

export const FormNumberInput = ({
    fieldName,
    label,
    placeholder,
    labelWidth,
    isRequired = false,
    isReadOnly = false,
    ...numberInputProps
}: {
    fieldName: string;
    label?: string;
    placeholder?: string;
    labelWidth?: string;
    isRequired?: boolean;
    isReadOnly?: boolean;
} & NumberInputProps &
    InputProps) => {
    const {
        register,
        formState: { errors },
    } = useFormContext();

    const { size, precision, step, ...numberInputStyles } = numberInputProps;

    if (isReadOnly) {
        return (
            <FormInput
                fieldName={fieldName}
                label={label}
                labelWidth={labelWidth}
                isRequired={isRequired}
                size={numberInputProps.size}
                isReadOnly
            />
        );
    }

    return (
        <FormControl isInvalid={!!errors[fieldName]} isRequired={isRequired}>
            <Flex direction="row" align="center">
                {label && <FormLabel fieldName={fieldName} labelWidth={labelWidth} label={label} />}
                <NumberInput size={size} w="100%" precision={precision} step={step}>
                    <NumberInputField
                        id={fieldName}
                        placeholder={placeholder || '-'}
                        {...numberInputStyles}
                        {...register(fieldName, { valueAsNumber: true })}
                    />
                    <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                    </NumberInputStepper>
                </NumberInput>
            </Flex>
            {errors[fieldName] && <FormErrorMessage>{String(errors[fieldName]?.message)}</FormErrorMessage>}
        </FormControl>
    );
};
